// APP
export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const AUTH_USER = "auth_user";
export const LOGOUT_USER = "logout_user";
export const GUEST_USER = "guest_user";
export const JUST_PAID = "just_paid";
export const AUTH_USER_APPOINTMENTS = "auth_user_appointments";
export const AUTH_PATIENT_APPOINTMENTS = "auth_patient_appointments";
export const LOADER_STATUS = "loader_status";
export const DOCTOR_SEARCH_LIST_LENGTH = "doctor_search_list_length";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

export * from "./menu/actions";
